import { render } from "./Register.vue?vue&type=template&id=4712beee&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=4712beee&lang=less&scoped=true"

import exportComponent from "D:\\xm\\zhongzai\\qianduan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4712beee"]])

export default __exports__